import React, { useContext } from "react";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import { ColorContext } from "./Bootstrap";

const StyledDataTableElement = styled(DataTable)`
  header {
    display: none;
  }

  .rdt_TableHead {
    border-bottom: 1px solid ${(props) => props.$mainColor || "var(--app-border)"};
    color: var(--app-ink);
    font-weight: 800;
  }

  .rdt_ExpanderRow {
    background-color: #fff;
  }

  .rdt_TableRow {
    transition: background-color 120ms ease-in;
  }
`;

export const StyledDataTable = (props) => {
  const mainColor = useContext(ColorContext);

  return <StyledDataTableElement {...props} $mainColor={mainColor} />;
};

export const darkTheme = {
  title: {
    height: 0,
    overflow: "hidden",
    padding: "0px",
    fontSize: "1.5em",
    fontWeight: "bold",
  },
  contextMenu: {
    backgroundColor: "#E91E63",
    fontColor: "#FFFFFF",
  },
  header: {
    fontSize: "14px",
    textTransform: "uppercase",
    fontColorActive: "000",
    fontColor: "#06283b",
    fontWeight: "bold",
    backgroundColor: "#f8fbfb",
  },
  rows: {
    fontSize: "16px",
    fontColor: "#06283b",
    backgroundColor: "#fff",
    borderColor: "#d7e2e5",
    hoverFontColor: "#06283b",
    hoverBackgroundColor: "#f3fbfa",
  },
  cells: {
    cellPadding: "18px 16px",
  },
  pagination: {
    fontColor: "#62727b",
    fontWeight: "bold",
    backgroundColor: "#fff",
    buttonFontColor: "#62727b",
    buttonHoverBackground: "#f3fbfa",
  },
  expander: {
    fontColor: "#000",
    backgroundColor: "#363640",
    expanderColor: "#000",
  },
  expanderRow: {
    backgroundColor: "#fff",
  },
};
